import React from "react";

import { colors as colorTokens } from "@zapalacorp/tokens";
import { ChartDataset } from "chart.js";
import { Line } from "react-chartjs-2";

import { IDashboardData } from "../../../../models/overview/dashboard";
import NotEnoughData from "../../../DashMetrics/NotEnoughData";

interface Props {
  colors?: string[] | string;
  datasets: IDashboardData[];
  labels: string[];
}

const OverviewLineGraph = ({ colors = colorTokens.brandBlue500, datasets, labels }: Props) => {
  if (!datasets[0].data.length) return <NotEnoughData />;

  const options = {
    elements: {
      line: {
        borderWidth: 1,
      },
      point: {
        backgroundColor: "white",
        borderWidth: 3,
        hoverRadius: 12,
        radius: 7,
      },
    },
    maintainAspectRatio: false,
    plugins: {
      legend: {
        align: "start" as const,
        display: false,
        labels: { padding: 8 },
        position: "bottom" as const,
      },
    },
    responsive: true,
    scales: { y: { grid: { display: false }, ticks: { padding: 0 } } },
  };

  return (
    <Line
      data={{
        datasets: datasets.map((dataset, idx) => ({
          ...dataset,
          borderColor: colors instanceof Array ? colors[idx] : colors,
        })) as ChartDataset<"line">[],
        labels,
      }}
      options={options}
    />
  );
};

export default OverviewLineGraph;
